import { useFormikContext } from "formik";
import { useEffect, useRef } from "react";


const FormikFocusError = () => {
  const { errors, isSubmitting, isValidating, submitCount } = useFormikContext();
  const lastSubmitCount = useRef(submitCount);

  useEffect(() => {
    if (submitCount === lastSubmitCount.current) {
      return;
    }
    lastSubmitCount.current = submitCount;

    if (!isValidating) {
      let keys = Object.keys(errors);
      if (keys.length > 0) {
        const errorElements = keys
          .map(key => document.getElementsByName(key)?.[0])
          .filter(element => element !== undefined);
        if (errorElements.length > 0) {
          const topmostElement = errorElements.reduce((topmost, current) => {
            const topmostRect = topmost.getBoundingClientRect();
            const currentRect = current.getBoundingClientRect();
            return currentRect.top < topmostRect.top ? current : topmost;
          });
          if (topmostElement) {
            topmostElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            topmostElement.focus();
          }
        }
      }
    }
  }, [submitCount, isValidating]);

  return null;
}

export default FormikFocusError;